<template>
  <v-container class="pa-0">
    <v-dialog max-width="55vmin" :value="showPreview" persistent>
      <v-card>
        <v-card-title>
          <div class="title" v-if="title">{{title}}</div>
          <v-spacer></v-spacer>
          <v-btn small dark icon color="grey" @click="$emit('close')" class="mx-0">
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field v-if="videoUrl" :value="videoUrl" solo readonly></v-text-field>
          <embed-player v-if="videoUrl" v-bind:value="videoUrl"></embed-player>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EmbedPlayer from "@/components/media/EmbedPlayer.vue";
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    videoUrl: {
      default: null
    },
    showPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EmbedPlayer
  }
};
</script>


